import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';

import { TagsComponent } from './tags.component';
import { TagsRoutingModule } from './tags.routing.module';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TagsRoutingModule
  ],
  exports: [
    TagsComponent
  ],
  declarations: [
    TagsComponent
  ]
})
export class TagsModule { }
